const COOKIE_BANNER_STATE_EVENT = 'cookie-banner:statechange';

const getCookieBannerState = () => {
  return window.eventKeeper?.heard(COOKIE_BANNER_STATE_EVENT);
};

const isCookieBannerOpen = (event) => {
  const detail = event?.detail || getCookieBannerState();

  if (detail?.visible || detail?.consentPending) {
    return true;
  }

  const cookie_banner = document.querySelector('cookie-banner');
  if (!cookie_banner) {
    return false;
  }

  if (
    cookie_banner.hasAttribute('data-consent-pending') ||
    cookie_banner.hasAttribute('data-visible')
  ) {
    return true;
  }

  const style = window.getComputedStyle(cookie_banner);

  return style.display !== 'none' && parseFloat(style.opacity) > 0;
};

const syncTapcartBanner = (event) => {
  const tapcart_banner = document.getElementById('tapcart-web-banner');

  if (!tapcart_banner) {
    return;
  }

  if (isCookieBannerOpen(event)) {
    tapcart_banner.style.display = 'none';
    tapcart_banner.style.visibility = 'hidden';
    tapcart_banner.style.opacity = '0';
    tapcart_banner.style.pointerEvents = 'none';
    return;
  }

  tapcart_banner.style.removeProperty('display');
  tapcart_banner.style.removeProperty('visibility');
  tapcart_banner.style.removeProperty('opacity');
  tapcart_banner.style.removeProperty('pointer-events');
};

const initTapcartBanner = () => {
  window.eventKeeper?.onEventHeard(COOKIE_BANNER_STATE_EVENT, (detail) => {
    syncTapcartBanner({ detail });
  });

  document.addEventListener(COOKIE_BANNER_STATE_EVENT, syncTapcartBanner);
  window.addEventListener('CookiebotOnConsentReady', syncTapcartBanner);

  syncTapcartBanner();

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', syncTapcartBanner, {
      once: true,
    });
    return;
  }

  const observer = new MutationObserver(syncTapcartBanner);
  observer.observe(document.body, { childList: true, subtree: true });

  const cookie_banner = document.querySelector('cookie-banner');
  if (cookie_banner) {
    observer.observe(cookie_banner, {
      attributes: true,
      attributeFilter: ['data-consent-pending', 'data-visible', 'style'],
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTapcartBanner, {
    once: true,
  });
} else {
  initTapcartBanner();
}
